import moment from 'moment';
import {
  createColumnsV2Common,
  createV2CommonFilters,
} from '../../../../aspects/V2CommonFields';
import {
  createColumnsV2Invoices,
  createV2InvoicesFilters,
} from '../../../../aspects/V2InvoiceFields';
import { CommonList } from '../../../../shared';

/**
 * Declare the additional columns to display (aspects)
 */
const columns: any[] = [
  ...createColumnsV2Invoices(),
  ...createColumnsV2Common(),
];

/**
 * Specific filters for orders
 */
const additionalFilters: any[] = [
  ...createV2InvoicesFilters(),
  ...createV2CommonFilters(),
];

/**
 * Order list component
 */
const DxV2InvoiceList = (props) => {
  return (
    <CommonList
      title='dxMessages.invoices.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      filterDefaultValues={{
        ingestDateAfter: moment()
          .subtract(4, 'hours')
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
      }}
    />
  );
};

export default DxV2InvoiceList;
